import React, { useEffect, useRef, useState } from 'react';
import { DataGrid, Box, DropDownBox, DateBox, SelectBox, Button } from 'devextreme-react';
import { Item } from "devextreme-react/box";
import {
    Paging,
    Pager,
    FilterRow,
    Column,
    Export,
    SearchPanel,
    Grouping,
    Summary,
    TotalItem,
    GroupItem
} from 'devextreme-react/data-grid';

import { _path } from "../../../data/headerNavigation";
import { formatDate, resources } from '../../../data/app';
import { cellRender, cellRenderBold, formatToMoneyNumber, onCellPreparedSales, onCellPreparedSales2, } from '../../../utils/common';


import http from '../../../utils/http';
import { dateByReport } from '../../../data/defaultObjects';
import { userService } from '../../../services/user.service';
import useAuthorization from '../../../hooks/useAuthorization';

const ResumenVentasPorCategoria = (props) => {

    const user = userService.getUser();

    const [areaId,] = useState(user.areaId);

    const [dateFrom, setDateFrom] = useState(dateByReport.from);
    const [dateTo, setDateTo] = useState(dateByReport.to);
    const [data, setData] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [_,] = useAuthorization(resources.verReporteDeVentas);
    //const [ options, setOptions ] = useState([]);

    let refData = useRef(null);


    const changeDateFrom = e => setDateFrom(e.value);

    const changeDateTo = e => setDateTo(e.value);

    const loadReport = () => {

        if (areaId > 0 && dateFrom && dateTo) {
            setLoading(true);
            http('reports/sales').asPost({ areaId, productId: null, from: dateFrom, to: dateTo, tipoFecha: 1, username: '' }).then(resp => {

                const data = resp;

                const groupedByProductAndFamily = Object.values(
                    data.reduce((acc, curr) => {
                        const key = `${curr.product}|${curr.family}`;

                        if (!acc[key]) {
                            acc[key] = {
                                family: curr.family,
                                product: curr.internalCode + '-' + curr.product,
                                quantity: 0,
                                cost: curr.cost,
                                price: curr.customPrice,
                                costoTotal: 0,
                                totalDetail: 0,
                                utilidades: 0,
                            };
                        }

                        acc[key].quantity += curr.quantity;
                        acc[key].costoTotal += curr.costoTotal;
                        acc[key].totalDetail += curr.totalDetail;
                        acc[key].utilidades += curr.utilidades;

                        return acc;
                    }, {})
                );

                const dataWithUtilidades = groupedByProductAndFamily.map(item => {
                    const utilidadesPorcentaje = item.totalDetail > 0 ? ((item.utilidades / item.totalDetail) * 100).toFixed(2) : 0;
                    return { ...item, utilidadesPorcentaje };
                });

                setData(dataWithUtilidades);

                setLoading(false);
            });
        }

    };

    const toMoney = data => formatToMoneyNumber(data.value);

    const title = 'Reporte de Ventas';

    const width = 140;

    return (
        <div className="">

            <Box direction="row" width="100%" height={75}>
                <Item ratio={1}>
                    <div className="ml-10">
                        <label>Desde:</label>
                        <DateBox type="date"
                            value={dateFrom}
                            displayFormat={formatDate}
                            openOnFieldClick={true}
                            onValueChanged={changeDateFrom} />
                    </div>
                </Item>
                <Item ratio={1}>
                    <div className="ml-10">
                        <label>Hasta:</label>
                        <DateBox type="date"
                            value={dateTo}
                            displayFormat={formatDate}
                            openOnFieldClick={true}
                            onValueChanged={changeDateTo} />
                    </div>
                </Item>

                <Item ratio={4}>
                    <div style={{ paddingTop: '19px' }}>
                        <Button
                            width={120}
                            text={`${loading ? 'Buscando...' : 'Buscar'}`}
                            type="default"
                            icon="search"
                            stylingMode="contained"
                            className="m-1"
                            disabled={loading}
                            onClick={loadReport}
                        />
                    </div>
                </Item>
            </Box>
            <Box direction="row" width="100%" height={75}>

                <Item ratio={1}>
                    <DataGrid
                        id="gridContainer"
                        ref={refData}
                        //keyExpr="date"
                        selection={{ mode: 'single' }}
                        dataSource={data}
                        showBorders={true}
                        showRowLines={true}
                        hoverStateEnabled={true}
                        onCellPrepared={onCellPreparedSales2}
                    >
                        <SearchPanel visible={true} width={200} />
                        <Grouping autoExpandAll={false} />
                        <Paging defaultPageSize={20} />
                        <Pager
                            showInfo={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={[20, 20, 50, 100, 500]}
                        />
                        <Export enabled={true} fileName={title} allowExportSelectedData={true} />

                        <Column dataField="family" caption="Categoria" groupIndex={0} />      
                        <Column dataField="product" caption="Producto" />             
                        <Column dataField="quantity" caption="Cantidad" cellRender={toMoney} width={width}  />
                        <Column dataField="cost" caption="Costo" cellRender={cellRender()} width={width} />
                        <Column dataField="costoTotal" caption="Costo Total" cellRender={cellRender()} width={width} />
                        <Column dataField="price" caption="Precio" cellRender={cellRender()} width={width} />
                        <Column dataField="totalDetail" caption="Total" cellRender={cellRender()} width={width} />
                        <Column dataField="utilidades" caption="Utilidades" cellRender={cellRender()} width={width} />
                        <Column dataField="utilidadesPorcentaje" alignment={'right'} caption="% Utilidades" width={width} customizeText={(data) => `${data.value} %`} />

                        <Summary>
                            <GroupItem column="quantity" summaryType="sum"  showInGroupFooter={false} customizeText={toMoney} alignByColumn={true}/>
                            {/* <GroupItem column="cost" summaryType="avg" showInGroupFooter={false} customizeText={toMoney} alignByColumn={true}/> */}
                            <GroupItem column="costoTotal" summaryType="sum" showInGroupFooter={false} customizeText={toMoney} alignByColumn={true}/>
                            {/* <GroupItem column="price" summaryType="avg" showInGroupFooter={false} customizeText={toMoney} alignByColumn={true}/> */}
                            <GroupItem column="totalDetail" summaryType="sum" showInGroupFooter={false} customizeText={toMoney} alignByColumn={true}/>
                            <GroupItem column="utilidades" summaryType="sum" showInGroupFooter={false} customizeText={toMoney} alignByColumn={true}/>
                            <GroupItem column="utilidadesPorcentaje" summaryType="avg" showInGroupFooter={false} customizeText={(data) => `${toMoney(data)} %`} alignByColumn={true}/>
                            <TotalItem column="product" summaryType="sum" customizeText={() => 'Totales :'} />
                            <TotalItem column="quantity" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="cost" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="totalDetail" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="utilidades" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="utilidadesPorcentaje" summaryType="avg" customizeText={(data) => `${toMoney(data)} %`} />    
                        </Summary>
                    </DataGrid>
                </Item>
            </Box>
        </div>
    );
}



export default ResumenVentasPorCategoria;
